function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "img-profile-placeholder-S@2x");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "path-1",
  cx: 23,
  cy: 23,
  r: 23
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "UID",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "v2.6-1-2.Summary-Overdue-$0.00&-Hover-button",
  transform: "translate(-196.000000, -367.000000)"
}, React.createElement("g", {
  id: "content",
  transform: "translate(165.000000, 158.000000)"
}, React.createElement("g", {
  transform: "translate(17.000000, 176.000000)",
  id: "btn-Manage-Account"
}, React.createElement("g", {
  transform: "translate(0.000000, 16.000000)"
}, React.createElement("g", {
  id: "img-profile-placeholder-S",
  transform: "translate(14.000000, 17.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "profile-base",
  fill: "#004A8C",
  xlinkHref: "#path-1"
}), React.createElement("path", {
  d: "M31.4,22.2 C33.0575,22.2 34.4,20.8575 34.4,19.2 C34.4,17.5425 33.0575,16.2 31.4,16.2 C29.7425,16.2 28.4,17.5425 28.4,19.2 C28.4,20.8575 29.7425,22.2 31.4,22.2 Z M31.4,17.4 C32.39375,17.4 33.2,18.20625 33.2,19.2 C33.2,20.19375 32.39375,21 31.4,21 C30.40625,21 29.6,20.19375 29.6,19.2 C29.6,18.20625 30.40625,17.4 31.4,17.4 Z M23,23.4 C25.32125,23.4 27.2,21.52125 27.2,19.2 C27.2,16.87875 25.32125,15 23,15 C20.67875,15 18.8,16.87875 18.8,19.2 C18.8,21.52125 20.67875,23.4 23,23.4 Z M23,16.2 C24.65375,16.2 26,17.54625 26,19.2 C26,20.85375 24.65375,22.2 23,22.2 C21.34625,22.2 20,20.85375 20,19.2 C20,17.54625 21.34625,16.2 23,16.2 Z M32.15,23.4 L30.65,23.4 C30.08,23.4 29.55125,23.58 29.10875,23.88375 C29.46125,24.12375 29.78,24.405 30.06125,24.72375 C30.245,24.645 30.44375,24.6 30.65,24.6 L32.15,24.6 C33.0575,24.6 33.8,25.40625 33.8,26.4 C33.8,26.73 34.07,27 34.4,27 C34.73,27 35,26.73 35,26.4 C35,24.74625 33.72125,23.4 32.15,23.4 L32.15,23.4 Z M14.6,22.2 C16.2575,22.2 17.6,20.8575 17.6,19.2 C17.6,17.5425 16.2575,16.2 14.6,16.2 C12.9425,16.2 11.6,17.5425 11.6,19.2 C11.6,20.8575 12.9425,22.2 14.6,22.2 Z M14.6,17.4 C15.59375,17.4 16.4,18.20625 16.4,19.2 C16.4,20.19375 15.59375,21 14.6,21 C13.60625,21 12.8,20.19375 12.8,19.2 C12.8,18.20625 13.60625,17.4 14.6,17.4 Z M26.00375,24.15 C24.75125,24.15 24.44,24.6 23,24.6 C21.56,24.6 21.24875,24.15 19.99625,24.15 C18.635,24.15 17.31125,24.7575 16.535,25.90875 C16.07,26.59875 15.8,27.4275 15.8,28.32 L15.8,30 C15.8,30.99375 16.60625,31.8 17.6,31.8 L28.4,31.8 C29.39375,31.8 30.2,30.99375 30.2,30 L30.2,28.32 C30.2,27.4275 29.93,26.59875 29.465,25.90875 C28.68875,24.7575 27.365,24.15 26.00375,24.15 L26.00375,24.15 Z M29,30 C29,30.33 28.73,30.6 28.4,30.6 L17.6,30.6 C17.27,30.6 17,30.33 17,30 L17,28.32 C17,27.6975 17.18375,27.09375 17.52875,26.58 C18.04625,25.81125 18.96875,25.35 19.9925,25.35 C21.02,25.35 21.3875,25.8 23,25.8 C24.6125,25.8 24.98,25.35 26.00375,25.35 C27.0275,25.35 27.95,25.81125 28.4675,26.58 C28.8125,27.09375 28.99625,27.6975 28.99625,28.32 L28.99625,30 L29,30 Z M16.89125,23.88375 C16.445,23.58 15.91625,23.4 15.35,23.4 L13.85,23.4 C12.27875,23.4 11,24.74625 11,26.4 C11,26.73 11.27,27 11.6,27 C11.93,27 12.2,26.73 12.2,26.4 C12.2,25.40625 12.9425,24.6 13.85,24.6 L15.35,24.6 C15.55625,24.6 15.755,24.645 15.93875,24.72375 C16.22,24.405 16.5425,24.12375 16.89125,23.88375 L16.89125,23.88375 Z",
  id: "ic-user",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})))))));

var SvgImgManageAccount = function SvgImgManageAccount(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgImgManageAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img-manage-account.4e59fd82.svg";
export { ForwardRef as ReactComponent };